import React from "react";
import { Spin } from "antd";

function Loader() {
  return <Spin fullscreen />;
}

export default Loader;
